import React from "react";

interface ComingSoonTransportProps {
  mode: "trains" | "buses" | "custom";
}

const ComingSoonTransport: React.FC<ComingSoonTransportProps> = ({ mode }) => {
  const gradientColors = {
    trains: "from-emerald-500 to-teal-700",
    buses: "from-amber-500 to-orange-700",
    custom: "from-purple-500 to-indigo-700",
  };

  const titles = {
    trains: "Train Bookings",
    buses: "Bus Bookings",
    custom: "Custom Transport",
  };

  return (
    <div className="w-full h-full relative rounded-xl overflow-hidden">
      <div
        className={`w-full h-full bg-gradient-to-br ${gradientColors[mode]} relative flex items-center justify-center`}
      >
        <div className="absolute inset-0 opacity-20">
          <div className="w-full h-full bg-[url('/patterns/topography.svg')] bg-repeat"></div>
        </div>
        <div className="relative z-10 text-center space-y-4 px-6">
          <h2 className="text-4xl font-bold text-white tracking-tight">
            {titles[mode]}
          </h2>
          <p className="text-lg text-white/90">Coming Soon</p>
          <p className="text-sm text-white/75 max-w-md">
            We're working hard to bring you the best{" "}
            {mode === "custom" ? "custom transport" : `${mode}`} booking
            experience. Stay tuned for updates!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonTransport;
